<template>
    <section>
        <div class="row mb-3 mt-4">
            <div class="col-md-3 col-sm-6">
                <div class="row">
                    <div class="col-auto">
                        <label class="font-weight-medium text-muted h4 mb-0 form-divider">Jabatan</label>
                    </div>
                    <div class="col-auto">
                        <h4 class="mb-0 font-weight-medium ">
                            {{ listRoles() }}
                        </h4>
                    </div>
                </div>
            </div>
            <div class="col-md-3 col-sm-6" v-if="Object.keys(guessBranch).length">
                <div class="row">
                    <div class="col-auto">
                        <label class="font-weight-medium text-muted mb-0 h4 form-divider">Cabang</label>
                    </div>
                    <div class="col-auto">
                        <h4 class="mb-0 font-weight-medium ">
                            {{ guessBranch.name }}
                        </h4>
                    </div>
                </div>
            </div>
            <div class="col-md-3 col-sm-6" v-if="employee.isCoordinator">
                <div class="row">
                    <div class="col-auto">
                        <label class="font-weight-medium text-muted mb-0 h4 form-divider">Mata Pelajaran Korbid</label>
                    </div>
                    <div class="col-auto">
                        <h4 class="mb-0 font-weight-medium ">
                            {{ employee.coordinator.subject.name }}
                        </h4>
                    </div>
                </div>
            </div>
            <div class="col-md-3 col-sm-6" v-if="employee.isTeacher">
                <div class="row">
                    <div class="col-auto">
                        <label class="font-weight-medium text-muted mb-0 h4 form-divider">Mata Pelajaran Pengajar</label>
                    </div>
                    <div class="col-auto">
                        <h4 class="mb-0 font-weight-medium ">
                            {{ listRelations(employee.teacher.subjects) }}
                        </h4>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3 col-sm-6">
                <!-- Section 1 -->
                <form v-on:submit.prevent="save" disabled>
                    <div class="card shadow-sm mb-4 border-0">
                        <div class="card-header background-primary">
                            <div class="row justify-content-end">
                                <div class="col">
                                    <span class="h4 font-weight-medium text-white mb-0">
                                        Profil Pegawai
                                    </span>
                                </div>
                                <div class="col-auto">
                                    <div class="edit-action">
                                        <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="toggleInput">
                                            Edit
                                        </button>
                                    </div>
                                    <div class="input-action">
                                        <button type="submit" class="btn btn-danger btn-sm btn-outline-white h4 my-0 mr-2">
                                            Save
                                        </button>
                                        <button type="button" class="btn btn-danger btn-sm btn-outline-white h4 my-0" v-on:click="toggleInput">
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row mb-3 align-items-center">
                                <div class="col-12">
                                    <div v-bind:style="'background-image: url(' + imagePreview +')'" class="user-avatar rounded-circle">
                                        <div class="overlay rounded-circle text-center text-white" v-on:click="$refs.upload.click()">
                                            <i class="fa fa-upload"></i>
                                        </div>
                                        <input ref="upload" type="file" class="form-control" v-on:change="preview" accept="image/*" />
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Username</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.employee.username" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" required />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Nama Lengkap</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.employee.name" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" required />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Nama Panggilan</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.employee.shortname" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" required />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Inisial</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-if="employee.user.isAdmin" v-model="form.employee.initial" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" required />
                                    <h4 v-else class="mb-0 font-weight-medium">{{ employee.initial }}</h4>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center" v-for="attribute in ['tempat_lahir']">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider">Tanggal Lahir</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <div class="wrapper-input">
                                        <datepicker v-model="form.profile.tanggal_lahir" v-bind:language="dateLanguage" full-month-name monday-first clear-button v-bind:disabled-dates="{from: new Date}" input-class="form-control form-control-sm"></datepicker>
                                    </div>
                                    <input v-if="form.profile.tanggal_lahir" class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" disabled v-bind:value="$moment(form.profile.tanggal_lahir, 'YYYY-MM-DD').format('D MMMM YYYY')" />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Jenis Kelamin</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <div class="wrapper-input">
                                        <div class="form-check form-check-inline py-1" v-for="gender in ['Laki-laki', 'Perempuan']">
                                            <div class="custom-control custom-radio">
                                                <input v-model="form.profile.jenis_kelamin" type="radio" class="custom-control-input" v-bind:value="gender" v-bind:id="'input-jenis_kelamin-' + gender" />
                                                <label class="custom-control-label h4" v-bind:for="'input-jenis_kelamin-' + gender">{{ gender }}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <input disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" v-bind:value="form.profile.jenis_kelamin"/>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center" v-for="attribute in ['agama', 'status_pernikahan']">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="col-md-3 col-sm-6">
                <!-- Section 2 -->
                <form v-on:submit.prevent="save" disabled>
                    <div class="card shadow-sm mb-4 border-0">
                        <div class="card-header background-primary">
                            <div class="row justify-content-end">
                                <div class="col">
                                    <span class="h4 font-weight-medium text-white mb-0">
                                        Kontak Pegawai
                                    </span>
                                </div>
                                <div class="col-auto">
                                    <div class="edit-action">
                                        <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="toggleInput">
                                            Edit
                                        </button>
                                    </div>
                                    <div class="input-action">
                                        <button type="submit" class="btn btn-danger btn-sm btn-outline-white h4 my-0 mr-2">
                                            Save
                                        </button>
                                        <button type="button" class="btn btn-danger btn-sm btn-outline-white h4 my-0" v-on:click="toggleInput">
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row mb-1 align-items-center" v-for="attribute in ['alamat', 'rt_rw', 'kel_kec_kota', 'kode_pos', 'telp_rumah']">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">No. HP</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.employee.phone" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" required />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider">Alamat Email</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.employee.email" type="email" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center" v-for="attribute in ['alumnus_bta', 'joined_at_bta']">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="col-md-3 col-sm-6">
                <!-- Section 3 -->
                <form v-on:submit.prevent="save" disabled>
                    <div class="card shadow-sm mb-4 border-0">
                        <div class="card-header background-primary">
                            <div class="row justify-content-end">
                                <div class="col">
                                    <span class="h4 font-weight-medium text-white mb-0">
                                        Histori Pendidikan
                                    </span>
                                </div>
                                <div class="col-auto">
                                    <div class="edit-action">
                                        <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="toggleInput">
                                            Edit
                                        </button>
                                    </div>
                                    <div class="input-action">
                                        <button type="submit" class="btn btn-danger btn-sm btn-outline-white h4 my-0 mr-2">
                                            Save
                                        </button>
                                        <button type="button" class="btn btn-danger btn-sm btn-outline-white h4 my-0" v-on:click="toggleInput">
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row mb-1 align-items-center" v-for="attribute in ['asal_sd', 'lulus_sd', 'asal_smp', 'lulus_smp', 'asal_sma', 'lulus_sma', 'asal_univ', 'fakultas_univ', 'jurusan_univ', 'lulus_univ']">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="col-md-3 col-sm-6">
                <!-- Section 4 -->
                <form v-on:submit.prevent="save" disabled>
                    <div class="card shadow-sm mb-4 border-0">
                        <div class="card-header background-primary">
                            <div class="row justify-content-end">
                                <div class="col">
                                    <span class="h4 font-weight-medium text-white mb-0">
                                        Data Keluarga Pegawai
                                    </span>
                                </div>
                                <div class="col-auto">
                                    <div class="edit-action">
                                        <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="toggleInput">
                                            Edit
                                        </button>
                                    </div>
                                    <div class="input-action">
                                        <button type="submit" class="btn btn-danger btn-sm btn-outline-white h4 my-0 mr-2">
                                            Save
                                        </button>
                                        <button type="button" class="btn btn-danger btn-sm btn-outline-white h4 my-0" v-on:click="toggleInput">
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row mb-1 align-items-center" v-for="attribute in ['nama_pasangan', 'tempat_lahir_pasangan']">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Tanggal Lahir Pasangan</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <div class="wrapper-input">
                                        <datepicker v-model="form.profile.tanggal_lahir_pasangan" v-bind:language="dateLanguage" full-month-name monday-first clear-button v-bind:disabled-dates="{from: new Date}" input-class="form-control form-control-sm"></datepicker>
                                    </div>
                                    <input v-if="form.profile.tanggal_lahir_pasangan" class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" disabled v-bind:value="$moment(form.profile.tanggal_lahir_pasangan, 'YYYY-MM-DD').format('D MMMM YYYY')" />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center" v-for="attribute in ['jumlah_anak']">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>
                            </div>
                            <template v-for="n in 5">
                                <div class="row mb-1 align-items-center">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted mb-0 h4 form-divider">Nama Anak {{ n }}</label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <input v-model="form.profile['nama_anak_' + n]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                    </div>
                                </div>
                                <div class="row mb-1 align-items-center">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted mb-0 h4 form-divider">Tempat Lahir Anak {{ n }}</label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <input v-model="form.profile['tempat_lahir_anak_' + n]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                    </div>
                                </div>
                                <div class="row mb-1 align-items-center">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted mb-0 h4 form-divider">Tanggal Lahir Anak {{ n }}</label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <div class="wrapper-input">
                                            <datepicker v-model="form.profile['tanggal_lahir_anak_' + n]" v-bind:language="dateLanguage" full-month-name monday-first clear-button v-bind:disabled-dates="{from: new Date}" input-class="form-control form-control-sm"></datepicker>
                                        </div>
                                        <input v-if="form.profile['tanggal_lahir_anak_' + n]" class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" disabled v-bind:value="$moment(form.profile['tanggal_lahir_anak_' + n], 'YYYY-MM-DD').format('D MMMM YYYY')" />
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3 col-sm-6">
                <!-- Section 5 -->
                <form v-on:submit.prevent="save" disabled>
                    <div class="card shadow-sm mb-4 border-0">
                        <div class="card-header background-primary">
                            <div class="row justify-content-end">
                                <div class="col">
                                    <span class="h4 font-weight-medium text-white mb-0">
                                        Data Kepegawaian
                                    </span>
                                </div>
                                <div class="col-auto">
                                    <div class="edit-action">
                                        <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="toggleInput">
                                            Edit
                                        </button>
                                    </div>
                                    <div class="input-action">
                                        <button type="submit" class="btn btn-danger btn-sm btn-outline-white h4 my-0 mr-2">
                                            Save
                                        </button>
                                        <button type="button" class="btn btn-danger btn-sm btn-outline-white h4 my-0" v-on:click="toggleInput">
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Golongan</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-if="employee.user.isAdmin" v-model="form.profile.golongan" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                    <h4 v-else class="mb-0 font-weight-medium">{{ employee.additionals.golongan }}</h4>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center" v-for="attribute in ['nomor_ktp']">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">NIP</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-if="employee.user.isAdmin" v-model="form.employee.identity" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                    <h4 v-else class="mb-0 font-weight-medium">{{ employee.identity }}</h4>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center" v-for="attribute in ['nomor_npwp', 'nomor_rekening', 'bank_rekening', 'nama_rekening']">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </section>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import { id } from 'vuejs-datepicker/dist/locale';
    import { employeeRoles, ROLE_EMPLOYEE_BRANCH_STAFF, ROLE_EMPLOYEE_TEACHER, ROLE_EMPLOYEE_COORDINATOR, ROLE_EMPLOYEE_MENTOR, ROLE_EMPLOYEE_BRANCH_HEAD } from '@/params.js';

    export default {
        name: "AccountEmployeeIndex",
        components: {
            Datepicker
        },
        data() {
            return {
                form: {
                    employee: {
                        name: '', identity: '', email: '', shortname: '', initial: '', phone: '', image: '', branchID: '', subjectID: '', roles: [], subjectIDs: []
                    },
                    profile: {
                        golongan: '', nomor_npwp: '', nomor_ktp: '', jenis_kelamin: 'Laki-laki', tempat_lahir: '', tanggal_lahir: '', agama: '',
                        bank_rekening: '', nomor_rekening: '', nama_rekening: '',
                        alamat: '', rt_rw: '', kel_kec_kota: '', kode_pos: '', telp_rumah: '',
                        asal_sd: '', lulus_sd: '', asal_smp: '', lulus_smp: '', asal_sma: '', lulus_sma: '', asal_univ: '', fakultas_univ: '', jurusan_univ: '', lulus_univ: '',
                        alumnus_bta: '', joined_at_bta: '',
                        status_pernikahan: '', nama_pasangan: '', tempat_lahir_pasangan: '', tanggal_lahir_pasangan: '', jumlah_anak: '',
                        nama_anak_1: '', tempat_lahir_anak_1: '', tanggal_lahir_anak_1: '',
                        nama_anak_2: '', tempat_lahir_anak_2: '', tanggal_lahir_anak_2: '',
                        nama_anak_3: '', tempat_lahir_anak_3: '', tanggal_lahir_anak_3: '',
                        nama_anak_4: '', tempat_lahir_anak_4: '', tanggal_lahir_anak_4: '',
                        nama_anak_5: '', tempat_lahir_anak_5: '', tanggal_lahir_anak_5: ''
                    }
                },
                employee: {user: {}},
                branches: [],
                subjects: [],
                roles: [],
                imagePreview: '',
                dateLanguage: id,
                guessBranch: {}
            };
        },
        methods: {
            save(event) {
                var formData = new FormData();
                for (var group in this.form) {
                    for (var attribute in this.form[group]) {
                        var value = this.form[group][attribute];
                        if (value instanceof Date) {
                            formData.set(group + '[' + attribute + ']', this.$moment(value).format('YYYY-MM-DD'));
                        } else if (Array.isArray(value)) {
                            for (var i = 0; i < value.length; i++) {
                                formData.append(group + '[' + attribute + '][]', value[i]);
                            }
                        } else {
                            formData.set(group + '[' + attribute + ']', value);
                        }
                    }
                }
                this.axios.post(process.env.API_URL + '/employee/profile', formData).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.toggleInput(event);
                        this.$store.dispatch('setProfile', {requestOptions: {meta: {throwError: false}}});
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            preview(event) {
                var input = event.currentTarget;
                if (input.files && input.files[0]) {
                    this.form.employee.image = input.files[0];
                    var reader = new FileReader();
                    reader.onload = function (event) {
                        this.imagePreview = event.target.result;
                    }.bind(this);
                    reader.readAsDataURL(input.files[0]);
                }
            },
            humanize(string) {
                return string.replace(/[_]+/g, ' ').replace(/^[a-z]| [a-z]/g, function (character) {
                    return character.toUpperCase();
                });
            },
            toggleInput(event) {
                var form = event.currentTarget ? event.currentTarget.form : event.target;
                var editMode = form.hasAttribute('disabled');
                if (editMode) {
                    var forms = document.querySelectorAll('form:not([disabled])');
                    for (var i = 0; i < forms.length; i++) {
                        this.formState(forms[i], false);
                    }
                    if (forms.length) {
                        this.fetchEmployee();
                    }
                } else {
                    this.fetchEmployee();
                }
                this.formState(form, editMode);
            },
            formState(form, editMode) {
                if (editMode) {
                    form.removeAttribute('disabled');
                } else {
                    form.setAttribute('disabled', 'disabled');
                }
                var inputs = form.getElementsByClassName('toggle-input');
                for (var i = 0; i < inputs.length; i++) {
                    var input = inputs[i];
                    if (editMode) {
                        input.classList.add('form-control');
                        input.classList.remove('form-control-plaintext');
                        input.removeAttribute("disabled");
                    } else {
                        input.classList.add('form-control-plaintext');
                        input.classList.remove('form-control');
                        input.setAttribute('disabled', 'disabled');
                    }
                }
            },
            listRelations(relations) {
                return typeof relations !== typeof undefined ? relations.map(object => object.name).join(', ') : '';
            },
            listRoles() {
                return this.listRelations(this.roles.filter(object => this.form.employee.roles.includes(object.id)));
            },
            fetchEmployee() {
                this.axios.get(process.env.API_URL + '/employee/profile').then(response => {
                    this.employee = response.data.data;
                    this.imagePreview = this.employee.imageUrl;

                    for (var key in this.employee) {
                        if (typeof this.employee[key] !== 'object') {
                            this.form.employee[key] = this.employee[key];
                        }
                    }
                    this.form.employee = Object.assign(this.form.employee, {
                        name: this.employee.user.name,
                        username: this.employee.user.username,
                        email: this.employee.user.email ? this.employee.user.email : '',
                        image: '',
                        branchID: '',
                        subjectID: '',
                        subjectIDs: [],
                        roles: []
                    });
                    for (var i in employeeRoles) {
                        if (this.employee['is' + employeeRoles[i].id]) {
                            this.form.employee.roles.push(employeeRoles[i].id);
                        }
                    }
                    var currentRoles = this.form.employee.roles;
                    if ([ROLE_EMPLOYEE_BRANCH_STAFF, ROLE_EMPLOYEE_MENTOR, ROLE_EMPLOYEE_BRANCH_HEAD].some(role => currentRoles.includes(role))) {
                        if (currentRoles.includes(ROLE_EMPLOYEE_BRANCH_STAFF)) {
                            this.guessBranch = this.employee.branchStaff.branch;
                        } else if (currentRoles.includes(ROLE_EMPLOYEE_MENTOR)) {
                            this.guessBranch = this.employee.mentor.branch;
                        } else if (currentRoles.includes(ROLE_EMPLOYEE_BRANCH_HEAD)) {
                            this.guessBranch = this.employee.branchHead.branch;
                        }
                        this.form.employee.branchID = this.guessBranch.id;
                    }
                    if (currentRoles.includes(ROLE_EMPLOYEE_TEACHER)) {
                        this.form.employee.subjectIDs = this.employee.teacher.subjects.map(subject => subject.id);
                    }
                    if (currentRoles.includes(ROLE_EMPLOYEE_COORDINATOR)) {
                        this.form.employee.subjectID = this.employee.coordinator.subjectID;
                    }
                    this.form.profile = this.employee.additionals;
                });
            }
        },
        created() {
            this.axios.all([
                this.axios.get(process.env.API_URL + '/branch'),
                this.axios.get(process.env.API_URL + '/subject')
            ]).then(this.axios.spread(function (responseBranch, responseSubject) {
                this.branches = responseBranch.data.data;
                this.subjects = responseSubject.data.data;
            }.bind(this)));

            this.roles = employeeRoles;
            
            document.title = 'Data Diri - ' + process.env.APP_NAME;
        },
        mounted() {
            this.fetchEmployee();
        }
    };
</script>

<style scoped>
    img:not([src]), img[src=""]{ display: none; }
    .btn.btn-outline-white { border-color: #fff; }
    .card-body { padding-left: 1.9rem; padding-right: 1.9rem; }

    form[disabled] .user-avatar .overlay{ display: none; }
    @media (max-width: 991.98px) {
        .form-divider::before{ display: none; }
    }
    form .edit-action, form[disabled] .input-action { display: none; }
    form .input-action, form[disabled] .edit-action { display: block; }

    form[disabled] select.form-control-plaintext { -moz-appearance: none; -webkit-appearance: none; appearance: none; }
    form:not([disabled]) .wrapper-input + .toggle-input, form[disabled] .wrapper-input { display: none; }
</style>


// WEBPACK FOOTER //
// src/components/profil/employee/Index.vue